import { jsx as _jsx } from "react/jsx-runtime";
import Button from '../../../../components/Button';
import Templates from '../../hooks';
import t from '../../../../lib/translate';
var SettingsPage = function () {
    var _a = Templates.useContainer(), translateTemplateKeys = _a.translateTemplateKeys, toggleTemplatTranslations = _a.toggleTemplatTranslations;
    return (_jsx("div", { children: _jsx(Button, { text: translateTemplateKeys
                ? t('templates.settings.turn.translations.off')
                : t('templates.settings.turn.translations.on'), onClick: toggleTemplatTranslations }) }));
};
export default SettingsPage;
